export default "__VITE_ASSET__3c018958__"